import styled from 'styled-components';

import { getRandomDelay } from '@/modules/promo';

interface ScSpinnerSlotsProps {
  slotMainImage: string;
  chunksImage: string;
  lastSlotElementPosition: number;
  borderSlotColor: string;
}

export const ScSpinnerSlots = styled.div<ScSpinnerSlotsProps>`
  background: url(${({ slotMainImage }) => slotMainImage}) center no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 528px;
  height: 312px;
  padding: 1.5rem;
  gap: 0.5rem;
  position: relative;
  width: 100%;

  & img {
    position: absolute;
    width: 100%;
    z-index: 100;
    animation: flame infinite ease-out;

    &:first-child {
      top: -57px;
      left: 0;
      animation-duration: ${getRandomDelay(1, 1)}s;
    }

    &:last-child {
      bottom: 13px;
      animation-duration: ${getRandomDelay(1, 1)}s;
    }
  }

  & .slots__container {
    width: 100%;
    height: 100%;
    border-radius: 1rem;
    overflow: hidden;
    position: relative;

    .slots__blur {
      position: absolute;
      left: 0;
      width: 100%;
      height: 100px;
      background-color: #00000000;
      z-index: 12;
      backdrop-filter: blur(2px);
      border-radius: 50px;

      &.top {
        top: -15%;
      }

      &.bottom {
        bottom: -15%;
      }
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 1rem;
      border: 4px solid transparent;
      background: ${({ borderSlotColor }) => borderSlotColor} border-box;
      -webkit-mask:
        linear-gradient(#fff 0 0) padding-box,
        linear-gradient(#fff 0 0);
      -webkit-mask-composite: destination-out;
      mask-composite: exclude;
      z-index: 20;
    }

    &:first-of-type {
      border-radius: 2rem 1rem 1rem 2rem;

      &::after {
        border-radius: 2rem 1rem 1rem 2rem;
      }
    }

    &:last-of-type {
      border-radius: 1rem 2rem 2rem 1rem;

      &::after {
        border-radius: 1rem 2rem 2rem 1rem;
      }
    }

    & .slots__wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      height: auto;
      width: 100%;
      transform: translateY(-4825px);
      gap: 1rem;
      animation-fill-mode: forwards;
      animation-timing-function: ease-in-out;

      & .slot {
        width: 128px;
        height: 128px;
        background-image: url(${({ chunksImage }) => chunksImage});
        animation-iteration-count: infinite;
        animation-duration: 1s;
      }
    }
  }

  @media (max-width: 560px) {
    zoom: 0.85;
  }

  @media (max-width: 500px) {
    zoom: 0.65;
  }

  @media (max-width: 370px) {
    zoom: 0.55;
  }

  @keyframes spin {
    0% {
      transform: translateY(-4825px);
    }

    100% {
      transform: translateY(
        ${({ lastSlotElementPosition }) => lastSlotElementPosition}px
      );
    }
  }

  @keyframes blink {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.6;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes flame {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.4;
    }

    100% {
      opacity: 1;
    }
  }
`;
